export const TITLE = 'Electronic Payment Details';
export const APPLYLABEL = 'Ok';
export const CANCELLABEL = 'Cancel';
